import { useSessionTimeout } from '../hooks/useSessionTimeout'
import styles from './SessionTimeoutWarning.module.css'

export default function SessionTimeoutWarning() {
  const { showWarning, remainingTime, extendSession, logout } = useSessionTimeout()

  if (!showWarning) return null

  const minutes = Math.floor(remainingTime / 60)
  const seconds = remainingTime % 60
  const timeDisplay = minutes > 0
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds} seconds`

  return (
    <div className={styles.overlay} role="alertdialog" aria-modal="true" aria-labelledby="timeout-title">
      <div className={styles.modal}>
        <div className={styles.icon}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h2 id="timeout-title" className={styles.title}>Session Expiring</h2>

        <p className={styles.message}>
          Your session will expire in <strong className={styles.time}>{timeDisplay}</strong> due to inactivity.
        </p>

        <p className={styles.submessage}>
          Would you like to stay logged in?
        </p>

        <div className={styles.actions}>
          <button onClick={logout} className={styles.logoutButton}>
            Log Out
          </button>
          <button onClick={extendSession} className={styles.extendButton}>
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  )
}
